import { formatDate } from '_utils';
import { AC_TYPES, LICENSE_POOL_TYPES, STATUS, TYPES } from '../../server/constants';
import { AC_OWNER_TYPE } from "_constants";
import { getLicensePoolProductLabel, getLicensePoolSublicensesLabelWithPrefix } from './licensePools';
import moment from 'moment';

export const getACLicenseOwnerType = lic => lic.activated_info.reseller_id ? AC_OWNER_TYPE.RESELLER : AC_OWNER_TYPE.INSTITUTION;

export const getACLicenseStatusLabel = lic => {
  if (lic.status === STATUS.NOT_ACTIVE) {
    return 'Deactivated';
  } else if (lic.expires_on && moment(lic.expires_on) < moment()) {
    return 'Expired';
  }
  return 'Active';
}

export const getExpiryDaysFromACLicense = lic => {
  if (lic.activated_info.expires_days_after_init && lic.activated_info.type === AC_TYPES.TERM_DAYS) {
    return lic.activated_info.expires_days_after_init;
  }
  return null;
};

export const getACLicenseIsInstPoolSub = lic => lic.license_pool && lic.license_pool.type === LICENSE_POOL_TYPES.SUBSCRIPTION;
export const getACLicenseIsUnclaimed = lic => lic.user === null && lic.user_id === null;

export const getACLicenseInstPoolSubExpiration = lic => formatDate(lic.license_pool.expires_on);

export const getExpiresOnTermDaysLabel = lic => {
  if (getACLicenseIsInstPoolSub(lic) && getACLicenseIsUnclaimed(lic)) {
    return `${getExpiryDaysFromACLicense(lic)} days after initialization or on ${getACLicenseInstPoolSubExpiration(lic)}`;
  } else if (getACLicenseIsUnclaimed(lic)) {
    return `${getExpiryDaysFromACLicense(lic)} days after initialization`;
  } else if (lic.expires_on) {
    return `${formatDate(lic.expires_on)} (${getExpiryDaysFromACLicense(lic)} day term)`;
  }
  return 'unknown';
};

export const getACLicenseExpiresOnLabel = lic => {
  if (lic.type === TYPES.FULL) {
    return 'never';
  } else if (lic.activated_info.type === AC_TYPES.TERM_DAYS) {
    return getExpiresOnTermDaysLabel(lic);
  } else if (lic.expires_on) {
    return formatDate(lic.expires_on);
  }
  return '';
};

export const getACLicenseTypeLabel = lic => {
  if (lic.type === TYPES.FULL) {
    return lic.name;
  } else if (lic.type === TYPES.SUBSCRIPTION) {
    return `${lic.name} temporary subscription`;
  } else if (lic.type === TYPES.TERM) {
    return `${lic.name} temporary`;
  }
  return 'unknown';
};

export const getACLicensePoolId = lic => lic && lic.license_pool ? lic.license_pool._id : '';
export const getACLicenseCode = lic => lic && lic.activated_info && lic.activated_info.ac_id ? lic.activated_info.ac_id : '';

export const getACLicensePoolLabel = lic => !lic || !lic.license_pool
  ? ''
  : `${getLicensePoolProductLabel(lic.license_pool)} ${getLicensePoolSublicensesLabelWithPrefix(lic.license_pool)}`.trim();

export const getACLicensePoolDescription = lic => lic && lic.license_pool ? lic.license_pool.description : '';

export const getACLicenseUserLabel = lic => !lic || !lic.user
  ? 'Unclaimed'
  : `${lic.user.displayname || lic.user.full_name} ${lic.user.email}`.trim();



// WEBPACK FOOTER //
// ./webAdmin/utils/activationCodes.js